import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { HTML_ATTRIBUTE_BLOCKER_ID, HTML_ATTRIBUTE_INLINE } from ".";
var SCRIPTS_SELECTOR = "script[src]:not([async]):not([defer]):not([".concat(HTML_ATTRIBUTE_BLOCKER_ID, "]):not([").concat(HTML_ATTRIBUTE_INLINE, "])");
/**
 * Create this instance at the time before adding content or scripts to your DOM,
 * and call the `.wait` function after adding content or scripts to your DOM.
 */

var WaitSynchronousScripts = /*#__PURE__*/function () {
  function WaitSynchronousScripts() {
    _classCallCheck(this, WaitSynchronousScripts);

    this.scriptsBefore = void 0;
    this.scriptsBefore = Array.prototype.slice.call(document.querySelectorAll(SCRIPTS_SELECTOR));
  }
  /**
   * Returns the diff of scripts as Promises and are resolved when script is loaded.
   */


  _createClass(WaitSynchronousScripts, [{
    key: "diff",
    value: function diff() {
      var _this = this;

      var scriptsAfter = Array.prototype.slice.call(document.querySelectorAll(SCRIPTS_SELECTOR));
      var scriptsDiff = scriptsAfter.filter(function (a) {
        return _this.scriptsBefore.indexOf(a) === -1;
      });
      var promises = scriptsDiff.map(function (script) {
        return new Promise(function (resolve) {
          // Check if the script is already loaded or in browser queue (https://stackoverflow.com/a/67184038/5506547)
          var performanceEntries = performance.getEntriesByType("resource").filter(function (_ref) {
            var name = _ref.name;
            return name === script.src;
          }); // `getEntriesByName` is not available in all browsers

          if (performanceEntries.length > 0) {
            resolve();
          }

          script.addEventListener("load", function () {
            resolve();
          });
          script.addEventListener("error", function () {
            // At the moment, we just ignore errors
            resolve();
          });
        });
      });
      return promises;
    }
  }]);

  return WaitSynchronousScripts;
}();

export { WaitSynchronousScripts };